exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-body.overflow-auto[data-v-cbd560f6]{overflow:auto}.pagination[data-v-cbd560f6]{display:inline-block!important}", ""]);

// exports
